import { AI_BUSINESS_CATEGORY_ID } from "@/utils/solutionDisplay";

/**
 * 判断 `/solutions` 的 `category` 查询参数是否应渲染 AI业务首页。
 *
 * 精确匹配：区分大小写，不 trim。`"AI-Business"`、`" ai-business"`、`""`、`null`
 * 均返回 false，由通用页处理。
 * 调用方应传入 `searchParams.get("category")`（多个 category 参数时只取第一个）。
 *
 * Validates: Requirements 2.1, 2.3, 2.7
 */
export function isAiOverviewCategory(value: string | null): boolean {
  return value === AI_BUSINESS_CATEGORY_ID;
}
